import React from 'react';

import css from './TopbarSearchForm.module.css';

const IconSearchDesktop = () => (
  <svg
    className={css.iconSvg}
    width="16"
    height="16"
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m19.613 18.21.094.083 8 8a1 1 0 0 1-1.32 1.497l-.094-.083-8-8a1 1 0 0 1 1.32-1.497M9.5 0a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19m0 2a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15" />
  </svg>
);

export default IconSearchDesktop;
